import { render, staticRenderFns } from "./updateCards.vue?vue&type=template&id=5cca91e2&"
import script from "./updateCards.vue?vue&type=script&lang=js&"
export * from "./updateCards.vue?vue&type=script&lang=js&"
import style0 from "./updateCards.vue?vue&type=style&index=0&id=5cca91e2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports